import {DateRangePill} from "~/components/dateRangePill";
import {
    applyCreatedAtDateRangeToFilters,
    readCreatedAtDateRangeFromFilters,
} from "~/components/ottopilotDataViewer/dataViewerDateRangeDefaults";
import type {FilterConfiguration} from "~/components/ottopilotDataViewer/filterConfiguration";
import type {Iso8601DateTime} from "@vesta/common-type-definitions/typeDefinitions";

export function readColumnDateRangeFromFilters(
    lineItems: FilterConfiguration["lineItems"],
    columnId: string,
): [Iso8601DateTime | null, Iso8601DateTime | null] {
    return readCreatedAtDateRangeFromFilters(lineItems, columnId);
}

export function applyColumnDateRangeToFilters(
    filterConfiguration: FilterConfiguration,
    range: [Iso8601DateTime | null, Iso8601DateTime | null],
    columnId: string,
): FilterConfiguration {
    return applyCreatedAtDateRangeToFilters(filterConfiguration, range, columnId);
}

export function FilterColumnDateRangePill({
    displayName,
    value,
    onChange,
    matchFilterPills = true,
    shouldRenderToParent = false,
    quickPresetLayout = "responsive",
}: {
    displayName: string;
    value: [Iso8601DateTime | null, Iso8601DateTime | null];
    onChange: (range: [Iso8601DateTime | null, Iso8601DateTime | null]) => void;
    matchFilterPills?: boolean;
    shouldRenderToParent?: boolean;
    quickPresetLayout?: "responsive" | "stacked" | "sidebar";
}) {
    const hasFilter = value[0] !== null && value[1] !== null;

    return (
        <DateRangePill
            value={value}
            onChange={onChange}
            emptyLabel={displayName}
            isSelected={hasFilter}
            matchFilterPills={matchFilterPills}
            shouldRenderToParent={shouldRenderToParent}
            maxDate={new Date()}
            showQuickPresets={true}
            quickPresetLayout={quickPresetLayout}
            onClear={
                hasFilter === true
                    ? () => {
                          onChange([null, null]);
                      }
                    : undefined
            }
        />
    );
}
